module.exports = __webpack_public_path__ + "static/media/oots-logo.81f645d7.svg";